import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getSupportListing, updateStatusSupport } from "../Redux/Actions/adminAction";
import Pagination from "../Components/Layout/Pagination";

export default function Support() {
  const dispatch = useDispatch();
  const { supportData: data, loading, error } = useSelector(
    (state) => state.usermgmtData
  );

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState(2);

  useEffect(() => {
    dispatch(getSupportListing({ page, limit, search, filter }));
  }, [dispatch, page, limit, search, filter]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setPage(1);
  };

  const handleStatusChange = async (supportId, status) => {
    try {
      await dispatch(updateStatusSupport({ supportId, status }));
      toast.success("Support ticket status updated successfully");
      dispatch(getSupportListing({ page, limit, search, filter }));
    } catch (error) {
      toast.error("Failed to update support ticket status");
    }
  };

  const renderPagination = () => {
    const items = [];
    for (let number = 1; number <= (data?.totalPages || 1); number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === page}
          onClick={() => setPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return items;
  };

  // Calculate open and closed counts client-side if not provided by API
  const openCount = data?.helpSupportList?.filter((s) => s.status === 0).length || 0;
  const closedCount = data?.helpSupportList?.filter((s) => s.status === 1).length || 0;

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Support</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  <Form.Control
                    type="search"
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Form.Group>
              </Col>
              {/* <Col
                xxl={9}
                xl={9}
                lg={8}
                md={8}
                className="d-flex justify-content-end align-items-center"
              >
                <div className="cmn-btn">
                  <Link to="#">DOWNLOAD</Link>
                </div>
              </Col> */}
            </Row>
          </div>
        </Container>
        <hr />
        <Container fluid>
          <div className="product-tab">
            <ul>
              <li>
                <Link
                  to="/Support"
                  className={filter === 2 ? "active-tab" : ""}
                  onClick={() => handleFilterChange(2)}
                >
                  ALL {data?.allTotalCount || 0}
                </Link>
              </li>
              <li>
                <Link
                  to="/Support"
                  className={filter === 0 ? "active-tab" : ""}
                  onClick={() => handleFilterChange(0)}
                >
                  Open {data?.openTotalCount || 0}
                </Link>
              </li>
              <li>
                <Link
                  to="/Support"
                  className={filter === 1 ? "active-tab" : ""}
                  onClick={() => handleFilterChange(1)}
                >
                  Closed {data?.closedTotalCount || 0}
                </Link>
              </li>
            </ul>
          </div>
        </Container>
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">
                {loading
                  ? "Loading..."
                  : `Showing ${(page - 1) * limit + 1} - ${Math.min(
                    page * limit,
                    data?.totalCount || 0
                  )} of ${data?.totalCount || 0} results`}
              </div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span>{" "}
                <Form.Select
                  aria-label="Default select example"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div className="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>Ticket Id</th>
                <th>Date</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Description</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.helpSupportList?.length > 0 ? (
                data.helpSupportList.map((support, index) => (
                  <tr key={support._id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>
                      {new Date(support.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </td>
                    <td>
                    
                        {support.userId?.full_name || ""}
                  
                    </td>
                    <td>{support.userId?.email || "-"}</td>
                    <td>{support.userId?.phone_number || "-"}</td>
                    <td>{support.description || support.message || "-"}</td>
                    {/* <td>
                      <div className="select-box">
                        <Form.Select
                          aria-label="Default select example"
                          value={support.status}
                          onChange={(e) =>
                            handleStatusChange(
                              support._id,
                              parseInt(e.target.value, 10)
                            )
                          }
                          disabled={loading}
                        >
                          <option value="">Select</option>
                          <option value={0}>Open</option>
                          <option value={1}>Closed</option>
                        </Form.Select>
                      </div>
                    </td> */}

                    <td>
                      <div className="select-box">
                        <Form.Select
                          aria-label="Default select example"
                          value={support.status}
                          onChange={(e) =>
                            handleStatusChange(
                              support._id,
                              parseInt(e.target.value, 10)
                            )
                          }
                          disabled={loading || support.status === 1}
                        >
                          {support.status === 0 ? (
                            <>
                              <option value={0}>Open</option>
                              <option value={1}>Closed</option>
                            </>
                          ) : (
                            <option value={1}>Closed</option>
                          )}
                        </Form.Select>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Support Tickets found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {data?.totalPages > 1 && (
          <Pagination
            totalstuff={data?.totalPages}
            limit={data?.limit}
            setpages={setPage}
          />
        )}

      </Container>
    </Layout>
  );
}